export const MIN_DESKTOP_WIDTH = 600

export const KNOWN_STATUS_CLASSES = [
  'status-not-submitted',
  'status-fake',
  'status-responded',
  'status-response-received',
  'status-submitted',
  'status-quote-submitted',
  'status-pending',
  'status-pending-review',
  'status-awaiting-response',
  'status-waiting',
  'status-needs-info',
  'status-needs-more-info',
  'status-additional-info-requested',
  'status-more-info-needed',
  'status-offer-made',
  'status-offer-pending',
  'status-offer-sent',
  'status-quote-sent',
  'status-buyout-offer',
  'status-buyout',
  'status-buyout-made',
  'status-buyout-sent',
  'status-consignment-offer',
  'status-consignment',
  'status-consignment-made',
  'status-consignment-sent',
  'status-buyback-offer',
  'status-buyback',
  'status-buyback-made',
  'status-buyback-sent',
  'status-accepted',
  'status-approved',
  'status-completed',
  'status-confirmed',
  'status-finalized',
  'status-rejected',
  'status-declined',
  'status-cancelled',
  'status-expired',
  'status-in-review',
  'status-processing',
  'status-under-review',
  'status-reviewing',
  'status-being-reviewed',
  'status-draft',
  'status-new',
  'status-buyout-consignment',
  'status-buyout-and-consignment',
  'status-shipped',
  // New API status classes
  'status-pending-authentication',
  'status-authentication-in-progress',
  'status-authenticated-no-offer',
  'status-authenticated-with-offer',
  'status-offer-pending',
  'status-offer-accepted',
  'status-in-transit',
  'status-received-at-warehouse',
  'status-converted-to-product',
  'status-counterfeit-detected',
  'status-needs-more-information',
  'status-picked-up'
]
